import React from "react";

import animation1 from "../img/animation1.jpg";
import animation2 from "../img/animation2.jpg";
import animation3 from "../img/animation3.jpg";
import animation4 from "../img/animation4.jpg";
import animation5 from "../img/animation5.jpg";

import painting1 from "../img/painting1.jpg";
import painting2 from "../img/painting2.jpg";
import painting3 from "../img/painting3.jpg";
import painting4 from "../img/painting4.jpg";
import painting5 from "../img/painting5.jpg";
import painting6 from "../img/painting6.jpg";



import sketching1 from "../img/sketching1.jpg";
import sketching2 from "../img/sketching2.jpg";
import sketching3 from "../img/sketching3.jpg";
import sketching4 from "../img/sketching4.jpg";

import biztech1 from "../img/BizTech1.jpg";
import biztech2 from "../img/BizTech2.jpg";
import biztech3 from "../img/BizTech3.jpg";
import biztech4 from "../img/BizTech4.jpg";
import biztech5 from "../img/BizTech5.jpg";
import biztech6 from "../img/BizTech6.png";


import covers1 from "../img/covers1.jpg";
import covers2 from "../img/covers2.jpg";
import covers3 from "../img/covers3.png";


import photo1 from "../img/Photo1.jpg";
import photo2 from "../img/Photo2.jpg";
import photo3 from "../img/Photo3.jpg";
import photo4 from "../img/Photo4.jpg";
import photo5 from "../img/Photo5.jpg";

import origami1 from "../img/origami1.jpg";
import origami2 from "../img/origami2.jpg";
import origami3 from "../img/origami3.jpg";
import origami4 from "../img/origami4.jpg";
import origami5 from "../img/origami5.jpg";
import origami6 from "../img/origami6.jpg";
import origami7 from "../img/origami7.jpg";
import origami8 from "../img/origami8.jpg";

import card1 from "../img/card1.jpg";
import card2 from "../img/card2.jpg";
import card3 from "../img/card3.jpg";
import card4 from "../img/card4.jpg";

import other1 from "../img/other1.jpg";
import other2 from "../img/other2.jpg";
import other3 from "../img/other3.jpg";



class Portfolio extends React.Component {
  render() {
    return (
      <section id="portfolio" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Art Portfolio</h3>
                <p className="subtitle-a">
                  illustrations & designs
                </p>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div>
            <h2>Illustrations</h2>
            <br></br>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={animation1} data-lightbox="gallery-vmarine">
                  <div className="work-img">
                    <img src={animation1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Animation</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Copic Markers
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={animation2}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={animation3}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={animation4}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={animation5}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={painting1} data-lightbox="gallery-aguadeluz">
                  <div className="work-img">
                    <img src={painting1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Painting</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Acrylic, Watercolors 
                          </span>{" "}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={painting2}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={painting3}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={painting4}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={painting5}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={painting6}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={sketching1} data-lightbox="gallery-todo">
                  <div className="work-img">
                    <img src={sketching1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Sketching</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Pencil
                          </span>
                          {/*} / <span className="w-date">18 Sep. 2018</span>*/}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={sketching2}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={sketching3}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={sketching4}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
          </div>
          {/* <div>
            <br></br>
            <h2>Design and Photography</h2>
            <br></br>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={biztech1} data-lightbox="gallery-medlingos">
                  <div className="work-img">
                    <img src={biztech1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Graphics (BizTech 2022)</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Figma, Procreate, Photoshop
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={biztech2}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={biztech3}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={biztech4}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={biztech5}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={biztech6}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={covers1} data-lightbox="gallery-smth">
                  <div className="work-img">
                    <img src={covers1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Covers & Infographics</h2>
                        <div className="w-more">
                          <span className="w-ctegory">Figma, Photoshop, Procreate</span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={covers2}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={covers3}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={photo1} data-lightbox="gallery-mf">
                  <div className="work-img">
                    <img src={photo1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Photography</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Photoshop
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={photo2}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={photo3}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={photo4}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={photo5}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
          </div> */}

          <div>
            <br></br>
            <h2>Cool Crafts</h2>
            <br></br>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={origami1} data-lightbox="gallery-origami">
                  <div className="work-img">
                    <img src={origami1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">3D Origami</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Paper
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={origami2}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={origami3}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={origami4}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={origami5}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={origami6}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={origami7}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={origami8}
                  data-lightbox="gallery-origami"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={card4} data-lightbox="gallery-card">
                  <div className="work-img">
                    <img src={card4} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Cardmaking</h2>
                        <div className="w-more">
                          <span className="w-ctegory">Copic Markers, Watercolors, Inks</span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={card1}
                  data-lightbox="gallery-card"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={card2}
                  data-lightbox="gallery-card"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={card3}
                  data-lightbox="gallery-card"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={other1} data-lightbox="gallery-other">
                  <div className="work-img">
                    <img src={other1} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Other</h2>
                        <div className="w-more">
                          <span className="w-ctegory">
                            Mixed Media, Felting
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={other2}
                  data-lightbox="gallery-other"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={other3}
                  data-lightbox="gallery-other"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
